module.exports = __webpack_public_path__ + "assets/fonts/Gotham-MediumItalic.0b6c1645.otf";